import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { useTheme } from 'styled-components';
import { AccordionComponent, AccordionContent, AccordionHeaderContent, AccordionHeader, AccordionMainTitle, AccordionSubtitle, AccordionTitle, AdditionalText, ArrowContainer } from './styles';
import { ChevronArrow } from '../ChevronArrow';
export var Accordion = function (_a) {
  var _b = _a.additionalText,
    additionalText = _b === void 0 ? null : _b,
    children = _a.children,
    contentColor = _a.contentColor,
    _c = _a.dataCyLabel,
    dataCyLabel = _c === void 0 ? 'accordion' : _c,
    _d = _a.fullWidth,
    fullWidth = _d === void 0 ? false : _d,
    _e = _a.isOpen,
    initialOpenState = _e === void 0 ? false : _e,
    _f = _a.subtitle,
    subtitle = _f === void 0 ? '' : _f,
    title = _a.title,
    _g = _a.titleCentered,
    titleCentered = _g === void 0 ? false : _g,
    titleColor = _a.titleColor,
    _h = _a.titleTextStyles,
    titleTextStyles = _h === void 0 ? {} : _h,
    _j = _a.variant,
    variant = _j === void 0 ? 'base' : _j,
    _k = _a.withoutHeaderMargin,
    withoutHeaderMargin = _k === void 0 ? false : _k,
    _l = _a.customClickableWrapper,
    customClickableWrapper = _l === void 0 ? false : _l,
    iconColor = _a.iconColor,
    onClick = _a.onClick;
  var theme = useTheme();
  var _m = useState(initialOpenState),
    isOpen = _m[0],
    setIsOpen = _m[1];
  useEffect(function () {
    setIsOpen(initialOpenState);
  }, [initialOpenState]);
  var onAccordionClick = function () {
    if (onClick) onClick();
    setIsOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
  };
  var isTextTitle = typeof title === 'string';
  return _jsxs(AccordionComponent, {
    "data-cy-label": dataCyLabel,
    withoutHeaderMargin: withoutHeaderMargin,
    variant: variant,
    children: [_jsxs(AccordionHeader, {
      titleCentered: titleCentered,
      customClickableWrapper: customClickableWrapper,
      color: titleColor,
      hasRichContent: !isTextTitle,
      "data-cy-label": "accordion-header",
      children: [_jsxs(AccordionHeaderContent, {
        "data-cy-label": "accordion-header-content",
        fullWidth: fullWidth,
        onClick: onAccordionClick,
        role: "unstyled",
        children: [_jsxs(AccordionTitle, {
          children: [_jsx(AccordionMainTitle, {
            "data-cy-label": "accordion-main-title",
            style: titleTextStyles,
            children: title
          }), subtitle && _jsx(AccordionSubtitle, {
            children: subtitle
          })]
        }), _jsx(ArrowContainer, {
          children: _jsx(ChevronArrow, {
            isOpen: isOpen,
            fillColor: iconColor !== null && iconColor !== void 0 ? iconColor : theme.tokens.interface.neutral.regular
          })
        })]
      }), additionalText && _jsx(AdditionalText, {
        "data-cy-label": "accordion-additional-text",
        children: additionalText
      })]
    }), _jsx(AnimateHeight, {
      height: isOpen ? 'auto' : 1,
      style: isOpen ? {} : {
        marginBottom: -1,
        visibility: 'hidden'
      },
      children: _jsx(AccordionContent, {
        "data-cy-label": "accordion-content",
        color: contentColor,
        children: children
      })
    })]
  });
};